import { EDeviceModel } from '@web/entities/connections/model/enums'

export const DeviceValue = {
  VP3701: 'vp3701',
  Devices: 'generator'
}

export const DeviceLabel = {
  VP3701: 'VP-3701',
  Generator: 'Генератор',
  Ltr24: 'LTR-24',
  Ltr51: 'LTR-51',
  LtrSync: 'SYNC',
  Controller: 'Контроллер MB210-101'
}

export const mapDeviceModel = {
  [EDeviceModel.VP3701]: DeviceLabel.VP3701,
  [EDeviceModel.LTR24]: DeviceLabel.Ltr24,
  [EDeviceModel.LTR51]: DeviceLabel.Ltr51,
  [EDeviceModel.GENERATOR]: DeviceLabel.Generator,
  [EDeviceModel.LTR_SYNC]: DeviceLabel.LtrSync,
  [EDeviceModel.CONTROLLER]: DeviceLabel.Controller
}
